import { render, staticRenderFns } from "./ReceivablesTable.vue?vue&type=template&id=21da0746&scoped=true&"
import script from "./ReceivablesTable.vue?vue&type=script&lang=js&"
export * from "./ReceivablesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da0746",
  null
  
)

export default component.exports